<template>
  <div class="rules">
    <!-- 导航栏 -->
    <van-sticky>
      <div
        :style="{
          width: '100%',
          backgroundColor: '#ffffff',
          height: statusBarHeight + 'px'
        }"
      ></div>
      <div class="nav-bar">
        <img @click="handelback" src="@/assets/icon_back.png" alt="" />
        <span class="nav-title" :class="{ ug: language == 'ug' }">
          {{ $t('排行榜规则') }}
        </span>
      </div>
    </van-sticky>
    <div class="content">
      <p :class="['content-title', language]">{{ $t('活动时间：') }}</p>
      <p>{{ $t('每周一0点~周日23:59:59') }}</p>
      <p :class="['content-title', language]">{{ $t('活动对象：') }}</p>
      <p>
        {{ $t('全平台在语音直播间送礼的用户 和 全平台在语音直播间收礼的用户') }}
      </p>
      <p :class="['content-title', language]">{{ $t('排行榜规则：') }}</p>
      <p>
        {{
          $t(
            '1、魅力榜：本周你收到的礼物总价值越高，你的排名就越高，礼物越贵，排名越好。'
          )
        }}
      </p>
      <p>
        {{
          $t(
            '2、豪气榜：你送出的礼物越多，你的排名越靠前，排名越高。'
          )
        }}
      </p>
      <p>{{ $t('3、一周为一个结算周期，本周活动结束后，排名清空重置。') }}</p>
      <p>
        {{
          $t('4、当前展示为上一周的排行情况，本周的排名将在下周一更新展示。')
        }}
      </p>
      <p>
        {{ $t('想在送礼排行榜上名列前茅吗？') }}<br />
        {{ $t('给你的好朋友狂送礼物吧！送的越多，排行上升越快！') }}
      </p>
      <p>{{ $t('别让自己无聊！现在就去送礼、收礼，提升你的等级！') }}</p>
    </div>
  </div>
</template>

<script>
import { CommonModule } from '@/store/modules/common'
import { appFunc_callExit } from '@/utils/bridge'
export default {
  data() {
    return {
      language: 'ug',
      statusBarHeight: 0
    }
  },
  created() {
    this.language = this.$route.query.language || 'en'
    CommonModule.setLanguage(this.language)
    this.$i18n.locale = this.language
    this.statusBarHeight = this.$route.query.statusBarHeight || 0
  },
  methods: {
    getLanguage(language) {
      return language
    },
    handelback() {
      if(this.$route.query.from) {
        appFunc_callExit()
        return
      }
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  height: 44px;
  background: #ffffff;
  border-bottom: 1px solid #f2f2f6;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 30px;
    height: 30px;
    position: absolute;
    left: 5px;
  }

  .nav-title {
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #181818;
  }
}

.content {
  padding: 16px 15px;

  p {
    font-weight: 400;
    font-size: 14px;
    color: #5c5c5c;
    line-height: 24px;
    padding-bottom: 10px;
  }

  .content-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 24px;
  }
}
</style>
